<template>
    <div>
        <a
            href="#"
            class="is-align-center is-space-between p-r-none tw:w-full"
            @click.prevent="isTemplatePreviewOpen = true; closeMenu()"
        >
            <span class="tw:flex tw:flex-nowrap tw:items-center tw:gap-2 tw:flex-1 tw:min-w-0">
                <component
                    :is="templateMenuLeadingIcon"
                    v-if="templateMenuLeadingIcon"
                    :size="18"
                    class="activity-title-icon tw:flex-shrink-0"
                    weight="bold"
                />
                <span
                    v-tooltip.right.hover="navTitleTooltip(templateNavTooltipText)"
                    class="nav-title-clamp-2 tw:flex-1 tw:min-w-0"
                >
                    <template v-if="shouldShowTemplatePrefix">
                        <strong class="activity-nav-label">{{ templateActivityMenuPrefix }}:</strong>
                        {{ item.text }}
                    </template>
                    <template v-else>{{ item.text }}</template>
                </span>
            </span>

            <template v-if="locked">
                <locked-item
                    v-if="hasPrerequisite"
                    :item="{
                        type: 'prerequisite',
                        namespace: 'activity_template',
                        position: 'is-right',
                        prereqTitle,
                    }"
                />

                <locked-item
                    v-else
                    :item="{
                        type: 'visibleAt',
                        namespace: 'activity_template',
                        visibleAt: titleText,
                        position: 'is-right',
                    }"
                />
            </template>
        </a>

        <teleport to="body">
            <e-modal v-model="isTemplatePreviewOpen" scroll="keep" has-modal-card :can-cancel="false">
                <template-preview :uuid="item.uuid" :parent-title="item.title" is-template @close="isTemplatePreviewOpen = false" />
            </e-modal>
        </teleport>
    </div>
</template>

<script>
import TemplatePreview from '@/components/modals/template-preview/TemplatePreview.vue';
import LockedItem from '@/components/nested-list/LockedItem.vue';
import {
    getActivityDisplayIcon,
    getActivityDisplayPrefix,
    normalizeActivityTypeKey,
} from '@/constants/activityDisplayMeta.js';
import SidebarMixin from '@/mixins/Sidebar.mixin.js';
import CourseTemplateMenuItem from '@/models/CourseTemplateMenuItem.js';
import { getActivityIcon, getActivityNavLabel } from '@/utilities/ActivityIcons.js';
import { navTitleTooltip } from '@/utilities/longTitleTooltip.js';

export default {
    name: 'ActivityTemplate',

    components: { TemplatePreview, LockedItem },

    mixins: [SidebarMixin],

    props: {
        closeMenu: {
            type: Function,
            default: () => {},
        },

        item: {
            type: CourseTemplateMenuItem,
            required: true,
        },
    },

    data: () => ({
        isTemplatePreviewOpen: false,
    }),

    computed: {
        templateActivityTypeKey() {
            const raw = this.item.activity_type_key ?? this.item.activity_type;
            const key = normalizeActivityTypeKey(raw);

            return key || null;
        },

        templateActivityMenuPrefix() {
            return getActivityDisplayPrefix(this.templateActivityTypeKey);
        },

        templateActivityMenuIcon() {
            return getActivityDisplayIcon(this.templateActivityTypeKey);
        },

        shouldShowTemplatePrefix() {
            return Boolean(this.templateActivityTypeKey && this.navLabel !== null);
        },

        templateMenuLeadingIcon() {
            if (!this.templateActivityTypeKey) {
                return null;
            }

            const raw = this.item.activity_type_key ?? this.item.activity_type;
            const fromMap = getActivityIcon(raw);
            if (fromMap) {
                return fromMap;
            }

            if (this.navLabel === null) {
                return null;
            }

            return this.templateActivityMenuIcon;
        },

        activityIcon() {
            return getActivityIcon(this.item.activity_type_key ?? this.item.activity_type);
        },

        navLabel() {
            return getActivityNavLabel(this.item.activity_type_key ?? this.item.activity_type);
        },

        templateNavTooltipText() {
            if (this.shouldShowTemplatePrefix) {
                return `${this.templateActivityMenuPrefix}: ${this.item.text}`;
            }

            return this.item.text;
        },
    },

    methods: {
        navTitleTooltip,
    },
};
</script>

